import { formatUuidT } from "../../../flatbuffers/display";

const ZERO_UUID = "00000000-0000-0000-0000-000000000000";

/**
 * True when an action_catalog record is bound to a bank.
 *
 * The wizard's `actionCatalogIds` gate the Actions step's auto-seed sweep:
 * when ANY catalog exists for the org the mount sweep is skipped (it assumes
 * the operator already has their actions). Legacy "phantom" catalogs — created
 * by an old decode-fail-to-CarCallLock(0) path and never attached to a bank
 * (no bank_id / no action_banks junction) — are invisible in the Actions table
 * (the hydrate effect drops any bank-less record) yet would still suppress
 * auto-generation for banks that genuinely have no actions. That is exactly the
 * "control messages not automatically added" defect on long-lived orgs.
 *
 * Excluding bank-less catalogs from `actionCatalogIds` keeps the gate honest:
 * only real, bank-bound catalogs count toward "the operator already has
 * actions". Reads both the FlatBuffer camelCase (`bankId`) and legacy JSON
 * (`bank_id`) spellings, and treats a zero UUID as unbound.
 */
export default function actionCatalogHasBankBinding(record: unknown): boolean {
  if (!record || typeof record !== "object") return false;
  const raw =
    (record as { bankId?: unknown; bank_id?: unknown }).bankId ??
    (record as { bank_id?: unknown }).bank_id;
  if (raw == null) return false;
  const asString = typeof raw === "object" ? formatUuidT(raw as never) : String(raw);
  return asString !== "" && asString !== "0" && asString !== ZERO_UUID;
}
